import { styled } from '@mui/material';

export const Center = styled('div')`
  margin: auto auto;
`;

export const CenterLeft = styled('div')`
  margin: auto auto auto 0;
`;
